import { Context, ReactNode } from 'react';
import useAsyncReducer from '../hooks/useAsyncReducer';
import { TCaseState } from '../reducer';

export interface IObjectContextType<T, A> {
	state: T;
	dispatch: (action: A) => Promise<void>;
	mutation: T extends TCaseState ? string : string | undefined;
}

export function createProvider<T, A>(
	Context: Context<IObjectContextType<T, A>>,
	reducer: any,
	initState: any,
	children: ReactNode,
	defaultMutation?: string
) {
	const [state, dispatch] = useAsyncReducer(reducer, initState);

	const value = {
		dispatch,
		state,
		...(defaultMutation && { mutation: defaultMutation }),
	} as IObjectContextType<T, A>;

	return <Context.Provider value={value}>{children}</Context.Provider>;
}
